import React from 'react';
import catWaveHiGif from '../assets/Q2/cat_wave_hi.gif';

function Q2({ question = 2, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm still a title</span>
        <h1>Project Valen</h1>
        <p>Well, that was easy...</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center">
      <span className="secretpin__title q2__greeting">Hi!</span>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q2__wave-button"
        onClick={() => onNavigate?.('q3')}
      >
        * Wave back *
      </button>
      <img src={catWaveHiGif} alt="" className="q2__gif" />
    </div>
  </div>
  );
}

export default Q2;
